import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Grid } from '../models/grid';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  myFiles: string[] = [];
  private userLoggedIn = new Subject<boolean>();
  // cartcount: any;
  expireAt: any;
  constructor(private http: HttpClient) {
    // this.cartcount = new BehaviorSubject<any>(0);

    this.userLoggedIn.next(false);
  }

  setUserLoggedIn(userLoggedIn: boolean) {
    this.userLoggedIn.next(userLoggedIn);
  }

  getUserLoggedIn(): Observable<boolean> {
    return this.userLoggedIn.asObservable();
  }

  commonPostHandler(url: string, data: any): Observable<any> {
    return this.http.post(url, data);
  }

  commonGetHandler(url: string): Observable<any> {
    return this.http.get(url);
  }
  commonGetByHandler(url: string): Observable<any> {
    return this.http.get(url);
  }

  commonPutHandler(url: string, data: any): Observable<any> {
    return this.http.put(url, data);
  }

  commonDeleteHandler(url: string): Observable<any> {
    return this.http.delete(url);
  }
  // getCheckoutApps() {
  //   const url = SubcriptionReminder.CART;
  //   this.commonGetHandler(url).subscribe(
  //     (res) => {
  //       this.cartCountHandler(res.count);
  //     },
  //     (error) => {}
  //   );
  // }
  // cartCountHandler(res) {
  //   this.cartcount.next(res);
  // }
  // cartCountSub() {
  //   return this.cartcount.asObservable();
  // }
  onGenerateJson(response: any, grid: Grid) {
    let jsonResponse: any;
    let elements = [];
    let ChildElements = [];
    let jsonData = {};
    let columnNames = [];
    let colValues = [];
    let result = {};
    // if (this.masterPageService.hideControls && this.masterPageService.hideControls.controlProperties) {
    //     if (this.masterPageService.hideControls.controlProperties.import) {
    //         grid.ImportVisible = true;
    //     }
    //     if (this.masterPageService.hideControls.controlProperties.export) {
    //         grid.ExportVisible = true;
    //     }
    //     if (this.masterPageService.hideControls.controlProperties.hideSearch) {
    //         grid.SearchVisible = false;
    //     }
    // }
    jsonResponse = {
      "SearchVisible": grid.SearchVisible,
      "SortDisabled": grid.SortDisabled,
      "ItemsPerPage": grid.ItemsPerPage,
      "EditVisible": grid.EditVisible,
      "launchVisible": grid.launchVisible,
      "makeVisible": grid.makeVisible,
      "ImportVisible": grid.ImportVisible,
      "ExportVisible": grid.ExportVisible,
      "EditHighlight": grid.EditHighlight,
      "DeleteVisible": grid.DeleteVisible,
      "WalletVisible": grid.WalletVisible,
      "CloseVisible": grid.CloseVisible,
      "ShowCheckbox": grid.ShowCheckbox,
      "CheckboxChecked": grid.CheckboxChecked,
      "PaginationVisible": grid.PaginationVisible,
      "EditAccess": grid.EditAccess,
      "DeleteAccess": grid.DeleteAccess,
      "SendVisible": grid.SendVisible,
      "AddLinesVisible": grid.AddLinesVisible,
      "SplitTrxVisible": grid.SplitTrxVisible,
      "AddSettingsVisible": grid.AddSettingsVisible,
      "ViewVisible": grid.ViewVisible,
      "PaginationId": Date.now(),
      "totalRecods": grid.totalRecods,
      "Elements": Response,
      "chatVisible": grid.chatVisible,
      "addTocart": grid.addTocart,
      "shortList": grid.shortList,
      "selected": grid.selected,
      "addTofavourite": grid.addTofavourite,
      "rating": grid.rating,
      "addToCrm": grid.addToCrm,
      "goToCrm": grid.goToCrm,
      "goToEC": grid.goToEC,
    }
    return jsonResponse;
  }


}
